<mat-dialog-content>
  <p class="default-message">Message: {{ defaultMessage }}</p>

  <mat-form-field appearance="fill" class="full-width">
    <mat-label>Additional Comment (optional)</mat-label>
    <textarea matInput [(ngModel)]="comment" placeholder="Add a comment..." rows="3"></textarea>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="center">
  <button mat-raised-button color="primary" (click)="onConfirmClick()">
    {{ confirmButtonText }}
  </button>
  <button mat-raised-button mat-dialog-close (click)="onCancelClick()">
    {{ cancelButtonText }}
  </button>
</mat-dialog-actions>